import { useEffect } from 'react';
import {
  HomeInsuranceAdLandingDetails,
  HomeInsuranceAdLandingHero,
} from '../components/HomeInsuranceAdLandingContent';
import '../components/CarInsuranceAdLandingContent.css';

function HomeInsuranceAdLandingPage() {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = 'Texas Home Insurance Quotes | GetSkimp';
    sessionStorage.setItem('insuranceType', 'home');
    return () => {
      document.title = previousTitle;
    };
  }, []);

  return (
    <div className="container car-ad-landing-page">
      <HomeInsuranceAdLandingHero />
      <div className="car-ad-form-details-divider" aria-hidden="true">
        <span>Learn more</span>
      </div>
      <HomeInsuranceAdLandingDetails />
    </div>
  );
}

export default HomeInsuranceAdLandingPage;
